"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRANSLATION = exports.SLIDEDOWN_CONTENT_ID = void 0;
var SLIDEDOWN_CONTENT_ID = "airasia-slidedown-content";
exports.SLIDEDOWN_CONTENT_ID = SLIDEDOWN_CONTENT_ID;
var TRANSLATION = {
  slideDownCta: 'Continue to add-ons'
};
exports.TRANSLATION = TRANSLATION;